"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ProductPay = _interopRequireDefault(require("@/components/ProductPay"));

//
//
//
//
var _default = {
  name: 'PayVip',
  components: {
    ProductPayTemplate: _ProductPay.default
  },
  data: function data() {
    return {
      type: 1
    };
  }
};
exports.default = _default;